@if (data.is_logged_in) {
  <aside class="sidebar">
    <div class="sidebar-brand">
      <img src="favicon.ico" alt="Bruchpilot" class="sidebar-favicon">
      <span>Bruchpilot</span>
    </div>

    <div class="sidebar-supplier">
      <i class="fa-solid fa-building"></i>
      @if (data.supplier_implementation.basic_supplier_info.name) {
        <span>{{ data.supplier_implementation.basic_supplier_info.name }}</span>
      } @else {
        <span class="sidebar-supplier-placeholder">No supplier loaded</span>
      }
    </div>

    <nav class="sidebar-nav">
      <a class="sidebar-link" [routerLink]="['/home']" routerLinkActive="active">
        <i class="fa-solid fa-house"></i>
        <span>Home</span>
      </a>

      @if (data.supplier_implementation) {
        <a class="sidebar-link" [routerLink]="['/meta']" routerLinkActive="active">
          <i class="fa-solid fa-sliders"></i>
          <span>Meta</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/direct_hit']" routerLinkActive="active">
          <i class="fa-solid fa-bullseye"></i>
          <span>Direct Hit</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/direct_hit_selectors']" routerLinkActive="active">
          <i class="fa-solid fa-code"></i>
          <span>Selectors</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/multiple_hits']" routerLinkActive="active">
          <i class="fa-solid fa-layer-group"></i>
          <span>Multi Hits</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/no_hits']" routerLinkActive="active">
          <i class="fa-solid fa-ban"></i>
          <span>No Hits</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/page_type']" routerLinkActive="active">
          <i class="fa-solid fa-tags"></i>
          <span>Classification</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/info']" routerLinkActive="active">
          <i class="fa-solid fa-floppy-disk"></i>
          <span>Save</span>
        </a>
        <a class="sidebar-link" [routerLink]="['/test_implementation']" routerLinkActive="active">
          <i class="fa-solid fa-flask"></i>
          <span>Test</span>
        </a>
      }
    </nav>

    <div class="sidebar-footer">
      <button class="sidebar-logout" (click)="onLogout()">
        <i class="fa-solid fa-right-from-bracket"></i>
        <span>Logout</span>
      </button>
    </div>
  </aside>
}
